'use client';

import { TrackingCallback } from '@growthbook/growthbook';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth-store-provider';
import { useGetEntitlements } from '@/entitlements/api/get';
import { useStatsigClient } from '@statsig/react-bindings';
import { useGrowthBook } from '@growthbook/growthbook-react';

export const onExperimentView: TrackingCallback = (experiment, result) => {
  rudderanalytics.track('Experiment Viewed', {
    experimentId: experiment.key,
    variationId: result.key
  });
};

export function GrowthBookTracking() {
  const gb = useGrowthBook();
  const authStore = useAuthStore();
  const { data: userEntitlements, isLoading } = useGetEntitlements();
  const userId = authStore.useTracked.userId() ?? '';
  const stableID = useStatsigClient().client.getContext().stableID;

  useEffect(() => {
    if (gb && stableID) {
      gb.updateAttributes({
        statsig_stable_id: stableID
      });
    }
  }, [gb, stableID]);

  useEffect(() => {
    if (gb && userId) {
      gb.updateAttributes({
        id: userId
      });
    }
  }, [gb, userId]);

  useEffect(() => {
    if (gb && !isLoading) {
      gb.updateAttributes({
        entitlements: userEntitlements
      });
    }
  }, [gb, isLoading, userEntitlements]);

  useEffect(() => {
    gb.fireDeferredTrackingCalls();
  }, [gb]);

  return null;
}
